// Shared workout type colors and utilities

export const WORKOUT_TYPE_COLORS = {
  'E': '#48bb78',   // Easy - Green
  'L': '#4299e1',   // Long - Blue
  'M': '#38b2ac',   // Marathon - Teal
  'T': '#ed8936',   // Threshold - Orange
  'I': '#f56565',   // Interval - Red
  'R': '#9f7aea',   // Repetition - Purple
  'ST': '#805ad5',  // Strides - Deep Purple
  'Rest': '#FFD700' // Rest - Yellow (primary)
};

export const WORKOUT_TYPE_NAMES = {
  'E': 'Easy',
  'L': 'Long',
  'M': 'Marathon',
  'T': 'Threshold',
  'I': 'Interval',
  'R': 'Repetition',
  'ST': 'Strides',
  'Rest': 'Rest'
};

export const getWorkoutTypeColor = (type) => {
  return WORKOUT_TYPE_COLORS[type] || '#718096';
};

export const getWorkoutTypeName = (type) => {
  return WORKOUT_TYPE_NAMES[type] || type;
};

export const getWorkoutTypeTextColor = (type) => {
  // Rest uses yellow background, so needs black text
  return type === 'Rest' ? '#0D0D0D' : 'white';
};
